import ttt from '@xingternal/ticktricktrack';
const trackFlagClick = ({ viewerId, otherId, displayFlag, }) => {
    ttt.event('PropTrackAction', {
        PropTrackAction: viewerId === otherId
            ? 'profile_self_badge_click'
            : 'profile_other_badge_click',
        PropActionOrigin: `${displayFlag.toLowerCase()}_member`,
    });
};
const trackCtaUrl = ({ url, isPremium, displayFlag, }) => {
    if (!url) {
        return '';
    }
    const newUrl = new URL(url);
    const isUpsellFlag = displayFlag === 'BASIC' || displayFlag === 'PREMIUM';
    if (!isPremium && isUpsellFlag) {
        newUrl.searchParams.append('sc_o', 'user_flag_upsell_click');
    }
    else {
        newUrl.searchParams.append('sc_o', 'user_flag_cta_click');
    }
    newUrl.searchParams.append('sc_o_PropActionOrigin', `${displayFlag.toLowerCase()}_member`);
    return newUrl.toString();
};
export { trackFlagClick, trackCtaUrl };
//# sourceMappingURL=tracking.js.map